import React from 'react';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import Paper from '@mui/material/Paper';

import type { ClientStatistic as ClientStatisticTypes } from '../../common/types/statistics/fbStatistics';
import TimeBetweenDates from './TimeBetweenDates';
import AgeStatistic from './AgeStatistic';
import InformationStatistic from './InformationStatistic';
import OptionStatistics from './OptionStatistics';
import MeasureStatistics from './MeasureStatistics';

type Props = {
  statistics: ClientStatisticTypes;
};

function ClientStatistics({ statistics }: Props) {
  return (
    <Paper
      variant='outlined'
      sx={{
        display: 'flex',
        flexDirection: 'column',
        margin: '24px 0',
        padding: '20px 24px',
        maxWidth: '650px',
        minWidth: '300px',
        backgroundColor: '#FAFAFA',
      }}
    >
      <Stack spacing={2}>
        <Typography fontSize='1.2rem' mb={2}>
          Fallauswertung
        </Typography>
        <TimeBetweenDates clientStatistics={statistics} />
        <AgeStatistic clientStatistics={statistics} />
        <InformationStatistic clientStatistics={statistics} />
        <OptionStatistics clientStatistics={statistics} />
        <MeasureStatistics clientStatistics={statistics} />
      </Stack>
    </Paper>
  );
}

export default ClientStatistics;
